<template lang="html">
  <nav class="nav">

    <template v-if="windowWidth > 570">
      <ul class="nav__container">
        <li
          @mouseenter="expandNavigationItem(null)"
         >
          <a class="nav__link" @click="getHome()">
            {{ $getTrans('home') }}
          </a>
        </li>

        <li
          v-for="(navigationItemLevel0, key) in items"
          v-if="navigationItemLevel0.hasOwnProperty('fields')"
          @mouseenter="expandNavigationItem(navigationItemLevel0)">

          <a
            v-if="!navigationItemLevel0.fields.hasOwnProperty('url') && ((navigationItemLevel0.navigationItems === undefined) || (navigationItemLevel0.navigationItems.length === 0))"
            @click="openDetail(navigationItemLevel0)"
            class="nav__link"
            :class="{ 'nav__link--expanded': navigationItemLevel0.expanded}">
            {{ navigationItemLevel0.hasOwnProperty('fields') ? navigationItemLevel0.fields.title : 'Empty' }}
          </a>
          <a
            v-else
            @click.prevent="expandNavigationItem(navigationItemLevel0); toggleSubNavigation(key); showCollapse=!showCollapse"
            class="nav__link"
            :class="{ 'nav__link--expanded': navigationItemLevel0.expanded}">
            {{ navigationItemLevel0.hasOwnProperty('fields') ? navigationItemLevel0.fields.title : 'Empty' }}
          </a>

        </li>
      </ul>

      <ul class="nav__container">
        <li v-for="(navigationItemLevel0, key) in items">
          <ul class="nav__container nav__container--sub">
            <li
              v-for="(navigationItemLevel1, key) in navigationItemLevel0.navigationItems"
              @mouseenter="expandNavigationItem(navigationItemLevel0, navigationItemLevel1)"
              :class="{ 'nav__link--invisible': !navigationItemLevel0.expanded || !isActive}">
              <a
                v-if="!navigationItemLevel1.fields.hasOwnProperty('linkURL') && !navigationItemLevel1.fields.hasOwnProperty('searchURL')"
                class="nav__link"
                @click="openDetail(navigationItemLevel1)">

                {{ navigationItemLevel1.hasOwnProperty('fields') ? navigationItemLevel1.fields.title : 'Empty' }}
              </a>
              <a
                v-if="navigationItemLevel1.fields.hasOwnProperty('linkURL')"
                class="nav__link"

                v-bind:href="navigationItemLevel1.fields.linkURL" target="_blank">
                {{navigationItemLevel1.fields.title}}
              </a>
               <a
                v-if="navigationItemLevel1.fields.hasOwnProperty('searchURL')"
                class="nav__link"
                @click="openSearch(navigationItemLevel1)"
               >
                {{navigationItemLevel1.fields.title}}
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </template>

    <template v-else>
      <div class="nav__container--mobile-blackout"></div>
      <ul class="nav__container nav__container--mobile">
        <li>
          <a class="nav__link" @click="getHome()">
            {{ $getTrans('home') }}
          </a>
        </li>

        <li
          v-for="(navigationItemLevel0, key, index) in items"
          >
          <a
            v-if="(navigationItemLevel0.navigationItems === undefined) || (navigationItemLevel0.navigationItems.length === 0)"
            @click="openDetail(navigationItemLevel0)"
            class="nav__link"
            :class="{ 'nav__link--expanded': navigationItemLevel0.expanded}">
            {{ navigationItemLevel0.hasOwnProperty('fields') ? navigationItemLevel0.fields.title : 'Empty' }}
          </a>
          <a
            v-else
            @click.prevent="expandNavigationItem(navigationItemLevel0); toggleSubNavigation(key); showCollapse=!showCollapse"
            class="nav__link"
            :class="{ 'nav__link--expanded': navigationItemLevel0.expanded}">
            {{ navigationItemLevel0.hasOwnProperty('fields') ? navigationItemLevel0.fields.title : 'Empty' }}
          </a>

          <!-- Sub navi mobile -->
          <ul
            :id="key"
            v-show="!showCollapse"
            class="nav__container nav__container--sub-mobile">
            <li
              v-for="(navigationItemLevel1, key) in navigationItemLevel0.navigationItems"
              :class="{ 'nav__link--invisible': !navigationItemLevel0.expanded || !isActive}">
              <a
                v-if="!navigationItemLevel1.fields.hasOwnProperty('linkURL') && !navigationItemLevel1.fields.hasOwnProperty('searchURL')"
                class="nav__link"
                @click="openDetail(navigationItemLevel1)">

                {{ navigationItemLevel1.hasOwnProperty('fields') ? navigationItemLevel1.fields.title : 'Empty' }}
              </a>
              <a
                v-if="navigationItemLevel1.fields.hasOwnProperty('linkURL')"
                class="nav__link"

                v-bind:href="navigationItemLevel1.fields.linkURL" target="_blank">
                {{navigationItemLevel1.fields.title}}
              </a>
              <a
                v-if="navigationItemLevel1.fields.hasOwnProperty('searchURL')"
                class="nav__link"
                @click="openSearch(navigationItemLevel1)"
              >
                {{navigationItemLevel1.fields.title}}
              </a>
            </li>
          </ul>
          <!--// Sub navi mobile -->

        </li>
      </ul>
    </template>

  </nav>
</template>

<script>
  import api from '@/api'
  import EventBus from '@/eventbus'

  export default {
    name: 'Navigation',
    props: [
      'navitems',
      'navactive'
    ],
    data () {
      return {
        items: this.navitems,
        windowWidth: 0,
        isActive: this.navactive,
        showSubNav: false,
        index: -1,
        showCollapse: false,
        region: 'verband'
      }
    },
    mounted () {
      // Get region
      this.getRegion()

      // Get the current viewport width
      this.windowWidth = this.getWindowWidth()
      this.$nextTick(() => {
        window.addEventListener('resize', this.getWindowWidth)

        // Get current viewport width if user changes it
        this.getWindowWidth()
      })

      // Prevend the background from scrolling
      document.getElementsByTagName('body')[0].style.overflow = 'hidden'
    },
    beforeDestroy () {
      EventBus.$off('mainnav')
      window.removeEventListener('resize', this.getWindowWidth)
      document.getElementsByTagName('body')[0].style.overflow = 'auto'
    },
    methods: {
      getRegion () {
        // Get region
        let region = this.$route.params.region
        if (region !== undefined) {
          this.region = region
        }
        // console.log('region: ', this.region)
      },
      expandNavigationItem (navigationItem, parentNavigationItem = null) {
        if (!parentNavigationItem) {
          if (this.items) {
            this.items.map((item) => {
              item.expanded = false
              this.isActive = false
            })
          }
        }

        if (navigationItem) {
          let navItemsSecondLevel = navigationItem.navigationItems
          if (navItemsSecondLevel !== null) {
            navigationItem.expanded = true
            this.isActive = true
          }
        }
      },
      openDetail (navigationItem) {
        // console.log('openDetail: ', navigationItem)
        let navTitle = ''
        let navId = ''
        let navUrl = ''

        if (navigationItem.fields.title) {
          // Beautify the title for the URL
          navTitle = this.$urlBeautify(navigationItem.fields.title)
        }

        if (navigationItem.sys.id) {
          navId = navigationItem.sys.id
        }

        // Populate the URL
        if (this.region) {
          navUrl = `/seite/bezirk/${this.region}/${navTitle}/${navId}`
        } else {
          navUrl = `/seite/${navTitle}/${navId}`
        }

        // Redirect to the requested page
        this.locationRedirect(navUrl)
      },
      openSearch (navigationItem) {
        EventBus.$emit('filledSearch', navigationItem.fields.url)
      },
      getHome () {
        let navUrl = '/'
        if (this.region) {
          if (this.region !== 'verband') {
            navUrl = `/bezirke/${this.region}`
          }
        }

        // Redirect to the requested page
        this.locationRedirect(navUrl)
      },
      locationRedirect (url) {
        // console.log('url 1: ', url)
        // console.log('this.region: ', this.region)

        let marketplaceTest = url.includes('marktplatz')
        let trainerTest = url.includes('trainerbrse')
        let contestTest = url.includes('turnierbrse')
        let shopTest = url.includes('shop')

        // console.log('testurl: ', marketplaceTest)
        // console.log('testurl: ', shopTest)

        if (marketplaceTest || trainerTest || contestTest || shopTest) {
          // console.log('this.region: ', this.region)

          if (shopTest) {
            url = `/${this.region}/shop`
          }

          if (trainerTest) {
            url = `/${this.region}/marktplatz/trainer_gesucht`
          }

          if (contestTest) {
            url = `/${this.region}/marktplatz/turniere`
          }
        }
        // console.log('url 2: ', url)

        // Redirect to the url
        this.$router.push({ path: `${url}` })

        // Close navi
        this.emitClick()
      },
      emitClick () {
        // send the click event to the parent
        this.$emit('closeNav', true)
      },
      getWindowWidth (event) {
        this.windowWidth = document.documentElement.clientWidth
      },
      toggleSubNavigation (index) {
        this.showCollapse = !this.showCollapse
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/includes/Navigation.vue